import { Component } from '@angular/core';

@Component({
  selector: 'app-quick-facts',
  templateUrl: './quick-facts.component.html',
  styleUrls: ['./quick-facts.component.scss']
})
export class QuickFactsComponent {

}
